import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import PropTypes from 'prop-types';
import { Input, Button, Tiny } from 'components';

const CreateDeliveryMethodForm = ({ onCancel }) => {
  const { formState, control } = useFormContext();
  const { errors } = formState;

  return (
    <div className="flex flex-col w-full md:w-40vw gap-y-2">
      <div className="flex flex-col w-full overflow-y-auto sm:h-full sm:gap-y-5 ">
        <Controller
          control={control}
          name="shortName"
          render={({ field }) => (
            <Input
              {...field}
              required
              maxLength={50}
              label="Teslimat Biçimi"
              errors={errors?.shortName?.message}
            />
          )}
        />
         <Controller
          control={control}
          name="formatCode"
          render={({ field }) => (
            <Input
              {...field}
              required
              maxLength={50}
              label="Teslimat Biçimi Kodu"
              id="code"
              errors={errors?.formatCode?.message}
            />
          )}
        />
        <Controller
          control={control}
          name="details"
          render={({ field }) => (
            <Input
              {...field}
              required
              maxLength={1000}
              label="Detay"
              errors={errors?.details?.message}
            />
          )}
        />
        <Controller
          control={control}
          name="description"
          render={({ field }) => (
            <Input
              {...field}
              required
              maxLength={50}
              label="Açıklama"
              errors={errors?.description?.message}
            />
          )}
        />
       
      </div>
      <div className="mt-4">
        <Tiny variant="error" className="ml-2">
          {errors?.countries?.message}
        </Tiny>
      </div>

      <div className="flex w-full gap-x-2">
        <Button
          text="Vazgeç"
          className="bg-ink p-3 ml-auto w-full sm:w-24"
          textVariant="white"
          onClick={onCancel}
        />
        <Button
          type="submit"
          text="Kaydet"
          className="bg-primary p-3 w-full sm:w-24"
          textVariant="white"
        />
      </div>
    </div>
  );
};

export default CreateDeliveryMethodForm;

CreateDeliveryMethodForm.propTypes = { onCancel: PropTypes.func };
